// Generated by `bazel run i18n`. Do not edit by hand.
import askRedo_af8ea2e6 from "./en/src--components--ask-redo.json";
import layouts_d325e61c from "./en/src--components--layouts.json";
import ui_11d11a58 from "./en/src--components--ui.json";
import core_2849f8b2 from "./en/src--core.json";
import hooks_9ba3ef56 from "./en/src--hooks.json";
import chargebacks_2237ec5e from "./en/src--steps--chargebacks.json";
import contextual_2ba5d2ea from "./en/src--steps--contextual.json";
import orderEditing_dae1adf7 from "./en/src--steps--order-editing.json";
import screens_972ad8d8 from "./en/src--steps--returns--portal--screens.json";
import portal_434837d9 from "./en/src--steps--returns--portal.json";
import returns_25c73e9a from "./en/src--steps--returns.json";
import packageComponents_80f99ea1 from "./en/src--steps--shipping-fulfillment--package-components.json";
import shippingFulfillment_1540ece3 from "./en/src--steps--shipping-fulfillment.json";
import steps_b90a4685 from "./en/src--steps.json";
import src_c1a2d0b5 from "./en/src.json";

export default Object.assign(
  {},
  askRedo_af8ea2e6,
  layouts_d325e61c,
  ui_11d11a58,
  core_2849f8b2,
  hooks_9ba3ef56,
  chargebacks_2237ec5e,
  contextual_2ba5d2ea,
  orderEditing_dae1adf7,
  screens_972ad8d8,
  portal_434837d9,
  returns_25c73e9a,
  packageComponents_80f99ea1,
  shippingFulfillment_1540ece3,
  steps_b90a4685,
  src_c1a2d0b5,
);
